function lowercaseAndRemoveSpaces(str) {
  if (typeof str !== 'string') {
    return '';
  }

  return str.toLowerCase().replace(/\s/g, '');
}

const checkLabelInclude = (a, b) => {
  const aLowercase = lowercaseAndRemoveSpaces(a);
  const bLowercase = lowercaseAndRemoveSpaces(b);
  return aLowercase.includes(bLowercase);
};

const dataModal = [
  {
    id: '1',
    value: '',
    accessKey: 'vehicle_number',
    label: 'Vehicle Number',
    type: 'OTHER',
    labelInclude: 'Vehicle Number'
  },
  {
    id: '2',
    value: '',
    accessKey: 'driver_name',
    label: 'Driver Name',
    type: 'OTHER',
    labelInclude: 'Name'
  },
  {
    id: '3',
    accessKey: 'challan_no',
    value: '',
    label: 'Challan No.',
    type: 'OTHER',
    labelInclude: 'Challan #'
  },
  {
    id: '4',
    accessKey: 'po_number',
    value: '',
    label: 'P.O. No.',
    type: 'PO_NUMBER',
    labelInclude: 'P.O. No'
  },
  {
    id: '5',
    accessKey: 'do_number',
    value: '',
    label: 'D.O. No.',
    type: 'PO_NUMBER',
    labelInclude: 'D.O. No'
  },
  {
    id: '6',
    accessKey: 'challan_date',
    value: '',
    label: 'Challan Date',
    type: 'OTHER',
    labelInclude: 'Challan Date'
  },
  {
    id: '7',
    accessKey: 'location_from',
    value: '',
    label: 'Consignor',
    type: 'RECEIVER_ADDRESS',
    labelInclude: 'Consigner'
  },
  {
    id: '8',
    accessKey: 'location_to',
    value: '',
    label: 'Consignee',
    type: 'RECEIVER_ADDRESS',
    labelInclude: 'Consignee'
  },
  {
    id: '9',
    accessKey: 'material',
    value: '',
    label: 'Material',
    type: 'OTHER',
    labelInclude: 'Material'
  },
  {
    id: '10',
    accessKey: 'gross_weight',
    value: '',
    label: 'Gross Weight',
    type: 'OTHER',
    labelInclude: 'Gross Weight'
  },
  {
    id: '11',
    accessKey: 'tare_weight',
    value: '',
    label: 'Tare Weight',
    type: 'OTHER',
    labelInclude: 'Tare Weight'
  },
  {
    id: '12',
    accessKey: 'net_weight',
    value: '',
    label: 'Net Weight',
    type: 'OTHER',
    labelInclude: 'Net Weight'
  },
  {
    id: '13',
    accessKey: 'actual_qty',
    value: '',
    label: 'Actual Qty',
    type: 'OTHER',
    labelInclude: 'Acutal Qty'
  },
  {
    id: '13',
    accessKey: 'driver_mobile',
    value: '',
    label: 'Driver Mobile',
    type: 'RECEIVER_PHONE',
    labelInclude: 'Mobile'
  }
];

export function filterChallanData(billData) {
  const typeData = {};
  let taxCount = 1;

  //Demo- print all data in console
  let sampleData = [];
  billData?.[0]?.['SummaryFields'].map(invoice => {
    let data = {};
    data['GroupProperties'] = invoice?.GroupProperties?.[0]?.Types?.[0];
    data['LabelDetection'] = invoice?.LabelDetection?.Text;
    data['Type'] = invoice?.Type?.['Text'];
    data['ValueDetection'] = invoice?.ValueDetection?.['Text'];

    sampleData.push(data);
  });

  console.table(sampleData);
  //Demo- print all data in console

  const formingData = dataModal?.map(item => {
    let copyItem = { ...item };

    // if (item.labelNotInclude) {
    //   if (bill?.Type?.Text === item.type) {
    //     if (bill?.LabelDetection?.Text) {
    //       if (
    //         checkWords(
    //           (bill?.LabelDetection?.Text || '').toLowerCase(),
    //           [...item.labelNotInclude],
    //           [item.labelInclude]
    //         )
    //       ) {
    //         copyItem['value'] = bill?.ValueDetection?.Text;
    //         copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

    //         return true;
    //       }
    //     } else {
    //       copyItem['value'] = bill?.ValueDetection?.Text;
    //       copyItem['accuracy'] = bill?.ValueDetection?.Confidence;
    //     }
    //   }
    // } else

    const findObj = billData?.[0]?.['SummaryFields'].find(bill => {
      if (item.labelInclude) {
        if (
          checkLabelInclude(bill?.LabelDetection?.Text, item.labelInclude)
          // bill?.Type?.Text === item.type &&
          // bill?.LabelDetection?.Text?.toLowerCase()?.includes(
          //   item.labelInclude?.toLowerCase()
          // )
        ) {
          copyItem['value'] = bill?.ValueDetection?.Text;
          copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

          return true;
        }
      } else if (bill?.Type?.Text === item.type) {
        copyItem['value'] = bill?.ValueDetection?.Text;
        copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

        return true;
      } else {
        copyItem['value'] = '';
        copyItem['accuracy'] = 0;

        return false;
      }
    });
    console.log('🚀 ~ findObj ~ findObj:', findObj);

    if (item.secondTry && copyItem?.value?.length === 0) {
      billData?.[0]?.['SummaryFields'].find(bill => {
        if (bill?.Type?.Text === item.type) {
          if (bill?.ValueDetection?.Text?.length > 0) {
            copyItem['value'] = bill?.ValueDetection?.Text;
            copyItem['accuracy'] = bill?.ValueDetection?.Confidence;

            return true;
          }
        }
      });
    }

    if (copyItem.type === 'TAX') {
      typeData[`${copyItem.type}${taxCount}`] = copyItem;
      taxCount++;
    } else {
      typeData[copyItem.accessKey] = copyItem;
    }

    return copyItem;
  });
  console.log('🚀 ~ formingData ~ formingData:', formingData);

  return {
    filteredData: billData?.length > 0 ? typeData : {},
    data: billData
  };
}
